<script setup lang="ts">
import BlockingPage from "@/components/BlockingPage.vue";
import { computed, onMounted } from "vue";
import { useAuthenticatedUserStore } from "@/services/store";

const props = defineProps<{ login: boolean }>();

const store = useAuthenticatedUserStore();

const header = computed(() => (props.login ? "Du skickas nu till inloggningen..." : "Du loggas nu ut..."));
const icon = computed(() =>
  props.login ? "i-material-symbols-login-outline-rounded" : "i-material-symbols-logout-outline-rounded",
);

onMounted(async () => {
  if (props.login) {
    const href = "/";
    await store.userLogin(href);
  } else {
    await store.userLogout();
  }
});
</script>

<template>
  <BlockingPage :header="header" :icon="icon" />
</template>
